import { initStore } from './store';
import { GlobalState, EventsState } from './storeTypes';
import { Event } from '../types/domain';

const configureStore = (): void => {
  const actions = {
    ADD_EVENTS: (curState: GlobalState, events: Event[]): Partial<GlobalState> => {
      console.debug('ADD_EVENTS DISPATCH FUNCTION');
      const updatedEvents: EventsState = {
        ...(curState.events || { events: [], isLoading: false }),
      };
      updatedEvents.events = events;
      return { events: updatedEvents };
    },
    UPDATE_EVENT: (curState: GlobalState, event: Event): Partial<GlobalState> => {
      console.debug('UPDATE_EVENT DISPATCH FUNCTION');
      const currentEvents = curState.events?.events || [];
      const eventIndex = currentEvents.findIndex((e) => e.eventId === event.eventId);
      // Build a NEW array (don't mutate the existing one) so downstream
      // consumers using referential equality (e.g. useEffect deps on the
      // events array) actually re-run. The previous in-place push/assign
      // was why the TopNav event-selector dropdown stayed stale after
      // creating a new event — both the eager dispatch from createEvent
      // and the onAddedEvent subscription wrote to the same array.
      const nextEvents =
        eventIndex === -1
          ? [...currentEvents, event]
          : currentEvents.map((e, i) => (i === eventIndex ? event : e));
      return {
        events: {
          ...(curState.events || { events: [], isLoading: false }),
          events: nextEvents,
        },
      };
    },
    DELETE_EVENTS: (curState: GlobalState, eventIdsToDelete: string[]): Partial<GlobalState> => {
      console.debug('DELETE_EVENT DISPATCH FUNCTION');
      const currentEvents = curState.events?.events || [];
      const updatedEvents: EventsState = {
        ...(curState.events || { events: [], isLoading: false }),
        events: currentEvents.filter((event) => !eventIdsToDelete.includes(event.eventId)),
      };
      return { events: updatedEvents };
    },
    EVENTS_IS_LOADING: (curState: GlobalState, isLoading: boolean): Partial<GlobalState> => {
      console.debug('EVENTS_IS_LOADING DISPATCH FUNCTION', isLoading);
      const updatedEvents: EventsState = {
        ...(curState.events || { events: [], isLoading: false }),
      };
      updatedEvents.isLoading = isLoading;
      return { events: updatedEvents };
    },
  };

  initStore(actions, { events: { events: [], isLoading: true } });
};

export default configureStore;
